module.exports = __webpack_public_path__ + "img/loading.cb7e87b0.png";